import React, { useEffect, useState, createElement } from 'react';
import { ArrowRightIcon, UsersIcon, MapPinIcon, ZapIcon, SearchIcon, LayoutIcon, CodeIcon, MousePointerClickIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { AlkmaarSkyline } from '../components/AlkmaarSkyline';
export function WebsiteLatenMakenAlkmaarPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Website laten maken Alkmaar | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Website laten maken in Alkmaar? Noord Digital bouwt professionele, conversiegerichte websites voor ondernemers in Alkmaar en omgeving. Vraag een vrijblijvend gesprek aan.';
  }, []);
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: 'Wat kost een website in Alkmaar?',
    a: 'De kosten voor een website in Alkmaar variëren afhankelijk van je wensen en het type website. Een eenvoudige bedrijfswebsite begint vanaf een paar honderd euro, terwijl maatwerk websites meer kosten. Wij geven altijd vooraf een transparante prijsopgave.'
  }, {
    q: 'Hoe lang duurt het om een website te maken?',
    a: 'Een standaard bedrijfswebsite is meestal binnen 2 tot 4 weken live. Voor complexere projecten plannen we samen een realistische tijdlijn. Wij houden je gedurende het hele proces op de hoogte.'
  }, {
    q: 'Kan ik mijn website zelf aanpassen?',
    a: 'Ja, wij bouwen onze websites met WordPress, zodat je zelf eenvoudig teksten en afbeeldingen kunt aanpassen. Na oplevering krijg je een uitgebreide uitleg en handleiding.'
  }];
  return <main className="pt-16 lg:pt-[72px]" data-id="element-2040" data-mp="udk32uvtxc0p">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-2041" data-mp="zblo3lctflet">
        <div className="absolute inset-0 pointer-events-none" data-id="element-2042" data-mp="148lvbzleiu7i">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-2043" data-mp="6mer4qt0f3vo" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-2044" data-mp="bkgbrg633b99" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-2045" data-mp="girj9k8wp9ob" />
        </div>

        {/* Alkmaar Skyline */}
        <div className="absolute bottom-0 left-0 right-0 opacity-[0.08] pointer-events-none" data-id="element-2046" data-mp="3oy1gadxxvop8">
          <AlkmaarSkyline className="w-full h-auto" color="#ffffff" data-id="element-2047" data-mp="2648c3bmfed1n" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2048" data-mp="223xxjakkieb6">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up" data-id="element-2049" data-mp="1x31u0y44ou6a">
            Website laten maken in Alkmaar
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto mb-10 animate-fade-in-up-delay-1" data-id="element-2050" data-mp="1n5x8n0i3x2qj">
            Professionele websites voor ondernemers in Alkmaar en omgeving. Wij
            zijn jouw lokale webdesigner met persoonlijke aanpak.
          </p>
          <div className="animate-fade-in-up-delay-2" data-id="element-2051" data-mp="1ebheawp3ggaa">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-bold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-lg" data-id="element-2052" data-mp="19ftoqg6p9l49">
              Plan een gesprek
              <ArrowRightIcon className="w-5 h-5" data-id="element-2053" data-mp="2zkx8sywrc2ok" />
            </a>
          </div>
        </div>
      </section>

      {/* Voor ondernemers in Alkmaar */}
      <section className="py-24 bg-surface-muted" data-id="element-2054" data-mp="2ptsu80azuju9">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2055" data-mp="2pqy7u38f6oy7">
          <div className="text-center mb-12" data-id="element-2056" data-mp="2uqsz47w3xgjs">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2057" data-mp="2gsckzvvx0nrm">
              Voor ondernemers in Alkmaar
            </h2>
          </div>
          <div className="max-w-3xl mx-auto text-center" data-id="element-2058" data-mp="2ls7dg3vc9les">
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-2059" data-mp="26uezhg5fx52p">
              Als webdesign bureau in Alkmaar begrijpen wij de lokale markt. Wij
              helpen ondernemers in Alkmaar, Heerhugowaard, Bergen, Heiloo en
              omgeving met professionele websites die klanten opleveren. Of je
              nu een nieuwe website nodig hebt of je huidige site wilt
              verbeteren — wij staan voor je klaar.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-2060" data-mp="1ukgupwi4vp98">
              Of je nu een nieuwe website wilt laten maken, beter gevonden wilt
              worden in Google, of je huidige website wilt vernieuwen en
              verbeteren. Wij staan voor je klaar.
            </p>
          </div>
        </div>
      </section>

      {/* Waarom een lokale webdesigner */}
      <section className="py-24 bg-white" data-id="element-2061" data-mp="2d9dsiacqozw7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2062" data-mp="2dchzffhla9qk">
          <div className="text-center mb-16" data-id="element-2063" data-mp="2981ylsmu1si7">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2064" data-mp="2n8l1ymgcsae1">
              Waarom een lokale webdesigner
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2065" data-mp="2iajn6dpymx8d">
              Kies voor een webdesign bureau in Alkmaar dat dichtbij is en met
              je meedenkt.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2066" data-mp="nwsdxfbjmfdg">
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-2067" data-mp="2nyi93v44k9ml">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2068" data-mp="2sxuqw1g52qib">
                <UsersIcon className="w-6 h-6 text-accent" data-id="element-2069" data-mp="2wxn4wtoaxov2" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2070" data-mp="31xrlejp7mjla">
                Persoonlijk contact
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2071" data-mp="36vt24xz5y6tl">
                Direct contact met je vaste webdesigner. Geen callcenter, maar
                een persoonlijke aanpak.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-2072" data-mp="3gn79frxcwaxa">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2073" data-mp="3kq3lt0wazass">
                <MapPinIcon className="w-6 h-6 text-accent" data-id="element-2074" data-mp="3pl965va24her" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2075" data-mp="3umgdjt8afekw">
                Lokale kennis
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2076" data-mp="8id3o6ax3f12">
                Wij kennen de Alkmaarse markt en weten wat werkt voor lokale
                ondernemers.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-2077" data-mp="3utr2bed5l4oh">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2078" data-mp="rb7jf2gd7b6c">
                <ZapIcon className="w-6 h-6 text-accent" data-id="element-2079" data-mp="mce6bb4zpm6p" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2080" data-mp="megstl6xox6o">
                Snelle communicatie
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2081" data-mp="dk2ebku89qom">
                Korte lijnen en snelle reactietijden. Binnen 24 uur antwoord op
                je vraag.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-2082" data-mp="15b8hyb95q6in">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-2083" data-mp="1oyh8g2hdh5ye">
                <SearchIcon className="w-6 h-6 text-accent" data-id="element-2084" data-mp="1tpz9eqjeb6jd" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2085" data-mp="1f135n5odgfok">
                Betere SEO
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2086" data-mp="1jz4obphvyczi">
                Geoptimaliseerd voor lokale zoekresultaten in Alkmaar en
                Noord-Holland.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Wat we bouwen */}
      <section className="py-24 bg-surface-muted" data-id="element-2087" data-mp="1xrcgf3y85frv">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2088" data-mp="1xqja2436gsa9">
          <div className="text-center mb-16" data-id="element-2089" data-mp="22pw356kn6vla">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2090" data-mp="22okqeh97ydi1">
              Wat we bouwen
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-2091" data-mp="meibjxgihphb">
              Van simpele bedrijfswebsites tot uitgebreide WordPress
              oplossingen.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2092" data-mp="35kulayr0ua1g">
            <div className="bg-white border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-2093" data-mp="30jex4xtjrneu">
              <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center mb-6" data-id="element-2094" data-mp="3ehlmtqoceh3f">
                <LayoutIcon className="w-6 h-6 text-navy-700" data-id="element-2095" data-mp="3ag9w1htqfptn" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2096" data-mp="2msry14jvjvi8">
                Bedrijfswebsites
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2097" data-mp="2hrm6ha1yaeaa">
                Een professioneel online visitekaartje dat jouw diensten en
                expertise presenteert aan klanten in Alkmaar.
              </p>
            </div>
            <div className="bg-white border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-2098" data-mp="233rbto4dtzuk">
              <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center mb-6" data-id="element-2099" data-mp="1z262uduyy5pn">
                <CodeIcon className="w-6 h-6 text-navy-700" data-id="element-2100" data-mp="17tdppxhhuafu" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2101" data-mp="12vc1yz94hmy1">
                WordPress websites
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2102" data-mp="ysfgn0s77cqe">
                Flexibele WordPress websites die je zelf eenvoudig kunt beheren
                en aanpassen.
              </p>
            </div>
            <div className="bg-white border border-navy-100 p-8 rounded-card hover:border-accent/30 transition-colors" data-id="element-2103" data-mp="oxdveg11mut3">
              <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center mb-6" data-id="element-2104" data-mp="k39k5kkqw0m7">
                <MousePointerClickIcon className="w-6 h-6 text-navy-700" data-id="element-2105" data-mp="f3n5d6p9qcba" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-2106" data-mp="b2bhb5m1lz57">
                Conversie websites
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-2107" data-mp="16i5jog5e9oh">
                Websites gebouwd om bezoekers om te zetten in klanten, met
                slimme call-to-actions en formulieren.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ons proces */}
      <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-2108" data-mp="2mrrl13fk7kea">
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-2109" data-mp="2mpnai2n5nn51" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2110" data-mp="1z1dqn69i59gj">
          <div className="text-center mb-16" data-id="element-2111" data-mp="2340nxmoxzml4">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-2112" data-mp="2327igaq2f8ep">
              Ons proces
            </h2>
            <p className="text-lg text-navy-300 max-w-2xl mx-auto" data-id="element-2113" data-mp="27wlg6js79rmj">
              In 5 heldere stappen naar jouw nieuwe website.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6" data-id="element-2114" data-mp="1fd4rgc9jk37j">
            {['Kennismaking', 'Strategie', 'Ontwerp', 'Ontwikkeling', 'Livegang'].map((step, i) => <div key={step} className="bg-white/[0.06] border border-white/10 p-6 rounded-2xl text-center relative" data-id="element-2115" data-mp="2sex1ugdp8z65" data-mpi={i}>
                <span className="absolute top-2 right-4 text-4xl font-bold text-white/[0.05]" data-id="element-2116" data-mp="2ngbxc4reztbw">
                  {i + 1}
                </span>
                <div className="w-10 h-10 rounded-full bg-accent/20 text-accent flex items-center justify-center mx-auto mb-4 font-bold" data-id="element-2117" data-mp="1ureh076rk6ls">
                  {i + 1}
                </div>
                <h3 className="text-white font-bold" data-id="element-2118" data-mp="24pc58uomi3ee">{step}</h3>
              </div>)}
          </div>
        </div>
      </section>

      {/* Gerelateerde pagina's */}
      <section className="py-16 bg-white border-b border-navy-100" data-id="element-2119" data-mp="3k49ooyoaxeeg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2120" data-mp="3g3g0s5auzzlk">
          <h3 className="text-lg font-semibold text-navy-900 mb-6" data-id="element-2121" data-mp="3nnh3t3tejly9">
            Ontdek meer:
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-2122" data-mp="3snd6mzqd57c8">
            <a href="#/website-laten-maken" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2123" data-mp="3dpuavdf9ptva">
              Website laten maken
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-2124" data-mp="a8kjt8yqocbc">•</span>
            <a href="#/wordpress-websites" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2125" data-mp="abgi4yei130b">
              WordPress websites
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-2126" data-mp="5hvp7krriz7z">•</span>
            <a href="#/hosting-onderhoud" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-2127" data-mp="5g12q20uez1s">
              Hosting & onderhoud
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-surface-muted" data-id="element-2128" data-mp="36h2afwrp75xi">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2129" data-mp="31geo3oeezd9m">
          <div className="text-center mb-16" data-id="element-2130" data-mp="31j0s5e23jan3">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-2131" data-mp="2wimkhx4eq2pl">
              Veelgestelde vragen
            </h2>
          </div>

          <div className="space-y-4" data-id="element-2132" data-mp="2rkutd5bl6kmg">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-soft overflow-hidden" data-id="element-2133" data-mp="3p5h28m9uanzd" data-mpi={index}>
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-2134" data-mp="3fg5y7e1t89ic">
                  <span className="font-bold text-navy-900" data-id="element-2135" data-mp="brvvdhuihyg8">{faq.q}</span>
                  {openFaq === index ? <ChevronUpIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-2136" data-mp="70dx51jvibyy" /> : <ChevronDownIcon className="w-5 h-5 text-navy-400 flex-shrink-0" data-id="element-2137" data-mp="fabh8ithmkcx" />}
                </button>
                {openFaq === index && <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-2138" data-mp="o9f1hq4e55t0">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <FinalCtaSection data-id="element-2139" data-mp="y7mcztfwuvnm" />
    </main>;
}